export const LEGACY_MAP = {
  "/our-clients": "/work",
  "/services": null,
  "/products-compare": "/products/eduanant",
  "/contact": null,
  "/about": null,
  "/it-services": "/services",
  "/page-404": "/",
  "/shop": "/services",
  "/my-account": "/contact",
  "/wishlist": "/",
  "/privacy-policy": "/legal/privacy",
  "/terms-condition": "/legal/terms",
  "/return-refund-and-cancellation-policy": "/legal/refunds",
  "/web_stories": "/work",
  "/web-stories": "/work",
  "/faq": "/contact",
  "/cart": "/",
  "/checkout": "/",
  "/fixed-contact-form": "/contact",
  "/e-commerce": "/services/e-commerce",
  "/app-development": "/services/mobile-apps",
  "/cloud-solutions": "/services/cloud-solutions",
  "/software-development": "/services/product-development",
  "/services/custom-software": "/services/product-development",
  "/web-development": "/services/web-development",
  "/ui-ux": "/services/ui-ux-design",
  "/creating-a-brand-identity-tips-for-designing-a-logo": "/services/branding",
  "/the-best-designing-services-company-for-your-business": "/services/branding",
  "/why-branding-and-design-is-important-for-business-growth": "/services/branding",
};

export const PREFIX_RULES = [
  ["/category/", "/work"],
  ["/tag/", "/work"],
  ["/author/", "/work"],
  ["/web-stories/", "/work"],
  ["/web_stories/", "/work"],
  ["/feed", "/"],
];

const NEW_EXACT = ["/work", "/blog", "/pricing", "/products"];
const NEW_PREFIXES = ["/services/", "/work/", "/blog/", "/products/"];

export const matchLegacy = (pathname) => {
  const clean = pathname.replace(/\/+$/, "") || "/";
  if (Object.prototype.hasOwnProperty.call(LEGACY_MAP, clean)) {
    const target = LEGACY_MAP[clean];
    if (target) return target;
    return pathname !== clean ? clean : null;
  }
  if (/^\/\d{4}\/\d{2}\//.test(clean)) return "/work";
  for (const [prefix, target] of PREFIX_RULES) {
    if (clean.startsWith(prefix)) return target;
  }
  if (pathname !== clean && (NEW_EXACT.includes(clean) || NEW_PREFIXES.some((p) => clean.startsWith(p)))) {
    return clean;
  }
  return null;
};
